import AppContext from "../Provider/AppContext";

import { useContext } from "react";

function useApp() {
  const props = useContext(AppContext);

  return { ...props };
}

export default useApp;
